"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TbDetailedDialog = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var TbDialog_1 = require("../TbDialog");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        tabs: {
            height: 38,
            minHeight: 38,
            marginBottom: 20,
            '& .MuiTabs-indicator': {
                backgroundColor: function (_a) {
                    var color = _a.color;
                    return color;
                },
                display: function (_a) {
                    var length = _a.length;
                    return length < 2 ? 'none' : 'block';
                }
            }
        },
        tab: {
            fontFamily: 'Montserrat',
            fontSize: '28px',
            textTransform: 'none',
            color: 'rgba(0,0,0,0.3)',
            padding: 0,
            minWidth: 0,
            marginRight: 20,
            maxWidth: 500,
            pointerEvents: function (_a) {
                var length = _a.length;
                return length < 2 ? 'none' : 'all';
            }
        },
        tabActive: {
            color: function (_a) {
                var color = _a.color;
                return color;
            }
        }
    });
});
var TbDetailedDialog = function (_a) {
    var open = _a.open, handleClose = _a.handleClose, handleSubmit = _a.handleSubmit, color = _a.color, loading = _a.loading, tabs = _a.tabs, activeTab = _a.activeTab, handleTabChange = _a.handleTabChange, width = _a.width, height = _a.height;
    var classes = useStyles({ color: color, length: tabs.length });
    var handleFormSubmit = function (e) {
        e.preventDefault();
        handleSubmit();
    };
    (0, react_1.useEffect)(function () {
        setTimeout(function () {
            window.dispatchEvent(new CustomEvent('resize'));
        }, 100);
    }, []);
    (0, react_1.useEffect)(function () {
        if (!open) {
            handleTabChange === null || handleTabChange === void 0 ? void 0 : handleTabChange(0);
        }
    }, [open]);
    return (react_1.default.createElement(TbDialog_1.TbDialog, { loading: loading, large: true, title: 'Title', color: color, open: open, closeButton: 'CANCEL', submitButton: 'SAVE CHANGES', handleSubmit: handleSubmit, handleClose: handleClose, width: width, height: height },
        react_1.default.createElement("form", { onSubmit: handleFormSubmit },
            react_1.default.createElement(core_1.Box, null,
                react_1.default.createElement(core_1.Tabs, { onChange: function (_, value) { return handleTabChange === null || handleTabChange === void 0 ? void 0 : handleTabChange(value); }, value: activeTab !== null && activeTab !== void 0 ? activeTab : 0, className: classes.tabs, "aria-label": 'basic tabs example' }, tabs.map(function (tab, i) {
                    return react_1.default.createElement(core_1.Tab, { key: "tab-switch-" + i, classes: { root: classes.tab, selected: classes.tabActive }, label: tab.title });
                }))),
            react_1.default.createElement("div", { style: { marginTop: 40 } }, tabs.map(function (tab, i) {
                return react_1.default.createElement("div", { key: "tab-" + i, hidden: activeTab !== i }, tab.content);
            })))));
};
exports.TbDetailedDialog = TbDetailedDialog;
exports.default = exports.TbDetailedDialog;
//# sourceMappingURL=TbDetailedDialog.js.map